function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.542 1L5.13 4.59M19.54 19l-3.588-3.589m-3.536 1.414c-.607.115-1.234.175-1.875.175C6.065 17 2.274 14.057 1 10a9.97 9.97 0 011.563-3.029m5.857.908a3 3 0 014.243 4.243M8.42 7.878l4.243 4.242M8.42 7.88l-3.29-3.29m7.533 7.532L5.131 4.59m7.532 7.532l3.29 3.29M5.13 4.59A9.953 9.953 0 0110.542 3c4.478 0 8.268 2.943 9.542 7a10.024 10.024 0 01-4.131 5.411",
  stroke: "#111827",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));